// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBFlwZ-5P7EoIGXXP0eCyM5buTqnwQo7zc",
  authDomain: "valetier-48bb4.firebaseapp.com",
  projectId: "valetier-48bb4",
  storageBucket: "valetier-48bb4.firebasestorage.app",
  messagingSenderId: "458141418610",
  appId: "1:458141418610:web:3533cd01113d10aae1eeeb",
  measurementId: "G-75F8BR2D59"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);

export default app;